import CarSuv from "./assets/img/icons/CarSuv";
import {
  menuWithoutIcon as carbonMenu,
  menuOnlyParentsWithIcon as carbonMenuWithIcon,
} from "./constants/carbon-constants";
import { activeFeature, apps, wording } from "./constants/constants";

export default {
  items:
    ["default", "pupuk"].findIndex((item) => item === apps) >= 0
      ? [
          {
            name: "Home",
            url: "/welcome",
            icon: "home icon",
            files: [
              "_nav.js",
              "goodsTraderIntercompanyNav.jsx",
              "hrNav.jsx",
              "maintenanceNav.jsx",
            ],
          },
          // {
          //   name: 'Enviroma Devices',
          //   url: '/enviroma/devices',
          //   icon: 'fa fa-microchip',
          // },
          // {
          //   name: 'Temperature',
          //   url: '/enviroma/temperature',
          //   icon: 'fa fa-thermometer-three-quarters',
          // },
          // {
          //   name: 'Air Pressure',
          //   url: '/airpressure',
          //   icon: 'fa fa-cloud',
          // },
          // {
          //   name: 'Humidity',
          //   url: '/humidity',
          //   icon: 'fa fa-tint',
          // },
          // {
          //   name: 'Alerts',
          //   url: '/alerts',
          //   icon: 'fa fa-bell',
          // },
          {
            name: "ConnectX",
            url: "/stocker",
            icon: "box icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            badge: {
              variant: "warning",
              text: "beta",
            },
            children: [
              {
                name: "My Stock",
                url: "/stocker/mystock",
                // icon: "fa fa-cubes",
                badge: {
                  variant: "info",
                  text: "▼",
                },
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                children: [
                  {
                    name: "Administrative Offices",
                    url: "/stocker/administrative-offices",
                    // icon: "fa fa-university",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Batchs",
                    url: "/stocker/batchs",
                    // icon: "fa fa-sitemap",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Brands",
                    url: "/stocker/brands",
                    // icon: "fa fa-bold",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Company Bank Accounts",
                    url: "/stocker/company-bank-accounts",
                    // icon: "fa fa-id-card",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Divisions",
                    url: "/stocker/divisions",
                    // icon: "fa fa-id-card",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Operating Areas",
                    url: "/stocker/operating-areas",
                    // icon: "fa fa-map",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Repackagings",
                    url: "/stocker/repacakaging",
                    // icon: "fa fa-archive",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Items",
                    url: "/stocker/items",
                    // icon: "boxes icon",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Item Settings",
                    url: "/stocker/item-settings",
                    // icon: "cog icon",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Vendors",
                    url: "/stocker/vendors",
                    // icon: "fa fa-handshake-o",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Opname",
                    url: "/stocker/opname/",
                    // icon: "fa fa-sort-numeric-asc",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "PIC Position",
                    url: "/stocker/pic-positions",
                    // icon: "fa fa-arrow-down",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Warehouse",
                    url: "/stocker/warehouse",
                    // icon: "fa fa-industry",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  // {
                  //   name: 'Warehouse Transfer',
                  //   url: '/stocker/warehouse-transfer',
                  //   icon: 'fa fa-exchange',
                  // },
                  {
                    name: "Rack Management",
                    url: "/stocker/rack-management",
                    // icon: "fa fa-table",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                ],
              },
              {
                name: "My Bound",
                url: "/stocker/mybound/",
                // icon: "fa fa-arrows-alt",
                badge: {
                  variant: "info",
                  text: "▼",
                },
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                children: [
                  //Inbounds
                  {
                    name: "Inbounds",
                    url: "/stocker/inbounds",
                    // icon: "fa fa-level-down",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },

                  {
                    name: "Outbounds",
                    url: "/stocker/outbounds",
                    // icon: "fa fa-level-up",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                ],
              },
              // {
              //   name: 'My Payment',
              //   url: '/',
              //   icon: 'fa fa-credit-card-alt',
              //   badge: {
              //     variant: 'info',
              //     text: '▼',
              //   },
              //   children: [
              //     {
              //       name: 'Payment Term',
              //       url: '/stocker/payment-term',
              //       icon: 'fa fa-money',
              //     },
              //   ]
              // },
              {
                name: "My Order",
                url: "/stocker/myorder/",
                // icon: "fa fa-shopping-basket",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                badge: {
                  variant: "info",
                  text: "▼",
                },
                children: [
                  //Sales
                  {
                    name: "Purchase Order",
                    url: "/stocker/purchase-order",
                    // icon: "fa fa-mail-reply",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  // {
                  //   name: 'Return Order',
                  //   url: '/stocker/return-order',
                  //   icon: 'fa fa-undo',
                  // },
                  {
                    name: "Sales Order",
                    url: "/stocker/sales-order",
                    // icon: "fa fa-mail-forward",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                ],
              },
              {
                name: "IOT Binding",
                url: "/stocker/iotbinding/",
                // icon: "fa fa-table",
                badge: {
                  variant: "info",
                  text: "▼",
                },
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                children: [
                  {
                    name: "User & Device",
                    url: "/stocker/user-and-device",
                    // icon: "fa fa-users",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Item Box",
                    url: "/stocker/item-box",
                    // icon: "box icon",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  // {
                  //   name: "Tagging",
                  //   url: "/stocker/tagging",
                  //   icon: "fa fa-tags",
                  // },
                ],
              },
            ],
          },
          {
            name: "TrackX",
            url: "/transporter",
            icon: "truck icon",
            files: [
              "_nav.js",
              "managerNav.jsx",
              "goodsTraderIntercompanyNav.jsx",
              "headMechanicNav.jsx",
              "securityNav.jsx",
              "mechanicNav.jsx",
              "hrNav.jsx",
              "maintenanceNav.jsx",
            ],
            children: [
              {
                name: "Main Dashboard",
                url: "/transporter/dashboard",
                // icon: "icon-speedometer",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "headMechanicNav.jsx",
                  "securityNav.jsx",
                ],
              },
              {
                name: "3PL Request",
                url: "/transporter/3pl/request",
                // icon: "fa fa-bullhorn",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "3PL Administrative",
                url: "/transporter/3pl/administrative",
                // icon: "fa fa-magic",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Divisions",
                url: "/transporter/divisions",
                // icon: "fa fa-id-card",
                files: ["_nav.js"],
              },
              {
                name: "Check Sheet",
                url: "/transporter/check-sheet",
                // icon: "fa fa-check-square-o",
                files: [
                  "_nav.js",
                  "goodsTraderIntercompanyNav.jsx",
                  "hrNav.jsx",
                  "maintenanceNav.jsx",
                ],
              },
              {
                name: wording["Delivery Orders"],
                url: "/transporter/delivery-order",
                // icon: "fa fa-file-text",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "securityNav.jsx",
                  "hrNav.jsx",
                  "maintenanceNav.jsx",
                ],
              },
              {
                name: wording["Delivery Order"] + "s Schedule Copy",
                url: "/transporter/delivery-order-schedule-copy",
                // icon: "fa fa-file-text",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "securityNav.jsx",
                  "hrNav.jsx",
                  "maintenanceNav.jsx",
                ],
              },
              {
                name: wording["Driver"],
                url: "/transporter/drivers",
                // icon: "fa fa-id-badge",
                files: [
                  "_nav.js",
                  "goodsTraderIntercompanyNav.jsx",
                  "hrNav.jsx",
                ],
              },
              {
                name: "Drivers Assistant",
                url: "/transporter/drivers-assistant",
                // icon: "fa fa-male",
                files: [
                  "_nav.js",
                  "goodsTraderIntercompanyNav.jsx",
                  "hrNav.jsx",
                ],
              },
              {
                name: wording["Fleets"],
                url: "/transporter/fleets",
                // icon: "fa fa-car",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                ],
              },
              // ...(activeFeature.ASSET_TRACKING
              //   ? [
              //       {
              //         name: "Assets",
              //         url: "/transporter/assets-fleet",
              //         // icon: "fa fa-car",
              //       },
              //     ]
              //   : []),
              {
                name: "Fleet Operations",
                url: "/transporter/fleet-operations",
                // icon: "map signs icon",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "maintenanceNav.jsx",
                ],
              },
              {
                name: "Mechanics",
                url: "/transporter/mechanics",
                // icon: "fa fa-user",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "headMechanicNav.jsx",
                ],
              },
              {
                name: wording["DO"] + " Category",
                url: "/transporter/delivery/category",
                // icon: "fa fa-tree",
                files: ["_nav.js", "hrNav.jsx"],
              },
              {
                name: "Fleet Maintenance",
                url: "/transporter/fleet-maintenance",
                // icon: "fa fa-wrench",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "headMechanicNav.jsx",
                  "mechanicNav.jsx",
                ],
              },
              // {
              //   name: 'Maintenance Settings',
              //   url: '/transporter/fleet-maintenance-settings',
              //   icon: 'fa fa-cogs',
              // },
              {
                name: "Live Monitoring",
                url: "/transporter/live-monitoring",
                // icon: "eye icon",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "securityNav.jsx",
                ],
              },
              {
                name: "Main Customers",
                url: "/transporter/main-customers",
                // icon: "fa fa-users",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Saved Places",
                url: "/transporter/saved-places",
                // icon: "bookmark icon",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                ],
              },
              // {
              //   name: 'Public Facility',
              //   url: '/transporter/public-facility',
              //   icon: 'fa fa-globe',
              // },
              {
                name: "Security",
                url: "/transporter/security",
                // icon: "shield alternate icon",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                ],
              },
              // {
              //   name: 'Workshop',
              //   url: '/transporter/workshop',
              //   icon: 'fa fa-file',
              // },
              ...(activeFeature.TIRE_MANAGEMENT || activeFeature.STORING
                ? [
                    {
                      name: "Accessories and Parts",
                      url: "/transporter/accessories-and-parts",
                      files: ["_nav.js"],
                      // icon: "fa fa-shield",
                      children: [
                        {
                          name: "Accessories and Parts",
                          url: "/transporter/accessories-and-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Brand Parts",
                          url: "/transporter/brand-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Category Parts",
                          url: "/transporter/category-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Distributor Parts",
                          url: "/transporter/distributor-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Quality Parts",
                          url: "/transporter/quality-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Storage Location Parts",
                          url: "/transporter/storage-location-parts",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                        {
                          name: "Sparepart Request",
                          url: "/transporter/sparepart-request",
                          // icon: "fa fa-shield",
                          files: ["_nav.js"],
                        },
                      ],
                    },
                  ]
                : []),

              ...(activeFeature.STORING
                ? [
                    {
                      name: "Storing",
                      url: "/storing",
                      files: ["_nav.js"],
                      // icon: "fa fa-shield",
                      children: [
                        {
                          name: "Fleet Trip",
                          url: "/storing/fleet/trip",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                        {
                          name: "Maintenance Mechanic",
                          url: "/storing/maintenance/mechanic",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                        {
                          name: "Maintenance Proof",
                          url: "/storing/maintenance/Proof",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                        {
                          name: "Maintenance Approval Type Setting",
                          url: "/storing/maintenance/approval/type/setting",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                      ],
                    },
                  ]
                : []),
              ...(activeFeature.STORING
                ? [
                    {
                      name: "Incident",
                      url: "/incident",
                      files: ["_nav.js"],
                      // icon: "fa fa-shield",
                      children: [
                        {
                          name: "Storing Ticket",
                          url: "/incident/storing-ticket",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                      ],
                    },
                  ]
                : []),
              ...(activeFeature.STORING
                ? [
                    {
                      name: "Scan",
                      url: "/scan",
                      files: ["_nav.js"],
                      // icon: "fa fa-shield",
                      children: [
                        {
                          name: "Activity Type",
                          url: "/scan/activity-type",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                        {
                          name: "Driver",
                          url: "/scan/driver",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                        {
                          name: "Mechanic",
                          url: "/scan/mechanic",
                          files: ["_nav.js"],
                          // icon: "fa fa-shield",
                        },
                      ],
                    },
                  ]
                : []),
            ],
          },
          // {
          //   name: 'Land Lord',
          //   url: '/landlord',
          //   icon: 'fa fa-industry',
          //   children: [
          //     {
          //       name: 'LL Monitoring',
          //       url: '/landlord/dashboard',
          //       icon: 'fa fa-stethoscope',
          //     },
          //     {
          //       name: 'Location Type',
          //       url: '/landlord/locationtype',
          //       icon: 'fa fa-bars',
          //     },
          //     {
          //       name: 'Location',
          //       url: '/landlord/locations',
          //       icon: 'fa fa-map-pin',
          //     },
          //     {
          //       name: 'Sensors',
          //       url: '/landlord/sensors',
          //       icon: 'fa fa-microchip',
          //     },
          //     {
          //       name: 'Utilities',
          //       url: '/landlord/utilities',
          //       icon: 'fa fa-shower',
          //     },
          //   ]
          // },
          ...(activeFeature.ASSET_TRACKING
            ? [
                {
                  name: "Asset Tracking",
                  url: "/asset-tracking",
                  icon: "map icon",
                  files: ["_nav.js"],
                  children: [
                    {
                      name: "Asset Category",
                      url: "/asset-tracking/category",
                      // icon: "fa fa-users",
                      files: ["_nav.js"],
                    },
                    {
                      name: "Asset List",
                      url: "/asset-tracking/list",
                      // icon: "fa fa-users",
                      files: ["_nav.js"],
                    },
                    {
                      name: "Asset Tracking Map",
                      url: "/asset-tracking/map",
                      // icon: "fa fa-user-circle",
                      files: ["_nav.js"],
                    },
                  ],
                },
              ]
            : []),
          {
            name: "DockX",
            url: "/point-hub",
            icon: "share alternate icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            children: [
              {
                name: "Customer",
                url: "/point-hub/customers",
                // icon: "fa fa-users",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Customer PIC",
                url: "/point-hub/customer-pic",
                // icon: "fa fa-user-circle",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Customer Bank Accounts",
                url: "/point-hub/customer-bank-accounts",
                // icon: "fa fa-id-card",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "3PL Group",
                url: "/transporter/3pl/grouping",
                // icon: "users icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Rentee",
                url: "/point-hub/rentee",
                // icon: "fa fa-truck",
                badge: {
                  variant: "info",
                  text: "NEW",
                },
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Maintenance Workshop",
                url: "/point-hub/maintenance-workshop",
                // icon: "fa fa-wrench",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Goods Trade",
                url: "/point-hub",
                // icon: "fa fa-handshake-o",
                files: ["goodsTraderIntercompanyNav.jsx"],
                badge: {
                  variant: "info",
                  text: "▼",
                },
                children: [
                  {
                    name: "Intercompany Order",
                    url: "/point-hub/intercompany-order",
                    // icon: "fa fa-building-o",
                    files: ["goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Pair As Vendor",
                    url: "/point-hub/intercompany-trading/vendor",
                    // icon: "fa fa-building-o",
                    files: ["goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Pair As Customer",
                    url: "/point-hub/intercompany-trading/customer",
                    // icon: "fa fa-user",
                    files: ["goodsTraderIntercompanyNav.jsx"],
                  },
                ],
              },
              // {
              //   name: 'Customer Approvals',
              //   url: '/point-hub/customer-approvals',
              //   icon: 'fa fa-check',
              // },
              // {
              //   name: 'PIC Positions',
              //   url: '/point-hub/pic-positions',
              //   icon: 'fa fa-arrow-down',
              // },
            ],
          },
          // {
          //   name: "cekcek",
          //   url: "/cek",
          //   icon: "leaf icon",
          //   files: ["_nav.js"],
          // },
          ...(activeFeature.MENUBAR_CARBONX_V2
            ? [{
                ...carbonMenu[carbonMenu.length-1],
                icon: "leaf icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              }]
            : [{
                name: "CarbonX",
                url: "/carbonx",
                icon: "leaf icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                children: [
                  {
                    name: "Main Dashboard",
                    url: "/carbonx/dashboard/",
                    // icon: "icon-speedometer",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Logger",
                    url: "/carbonx/logger/",
                    // icon: "fa fa-terminal",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                    badge: {
                      variant: "info",
                      text: "▼",
                    },
                    children: [
                      //Inbounds
                      {
                        name: "Scope 1",
                        url: "/carbonx/logger/scope1",
                        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                        // icon: "fa fa-truck",
                      },
                      {
                        name: "Scope 2",
                        url: "/carbonx/logger/scope2",
                        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                        // icon: "fa fa-bolt",
                      },
                      {
                        name: "Scope 3",
                        url: "/carbonx/logger/scope3",
                        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                        // icon: "fa fa-share",
                      },
                    ],
                  },
                  {
                    name: "Carbon Invoice",
                    url: "/carbonx/invoice",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                    // icon: "fa fa-file-text-o",
                  },
                  {
                    name: "Data Market",
                    url: "/carbonx/data-market",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                    // icon: "fa fa-database",
                  },
                  // {
                  //   name: 'Settings',
                  //   url: '/enermo/settings',
                  //   icon: 'fa fa-cogs',
                  // },
                ],
              }]),
          // {
          //   name: "CarbonX",
          //   url: "/point-hub",
          //   icon: "leaf icon",
          //   children: [
          //     ...(activeFeature.MENUBAR_CARBONX_V2
          //       ? carbonMenu
          //       : [
          //           {
          //             name: "Main Dashboard",
          //             url: "/carbonx/dashboard/",
          //             // icon: "icon-speedometer",
          //           },
          //           {
          //             name: "Logger",
          //             url: "/carbonx/logger/",
          //             // icon: "fa fa-terminal",
          //             badge: {
          //               variant: "info",
          //               text: "▼",
          //             },
          //             children: [
          //               //Inbounds
          //               {
          //                 name: "Scope 1",
          //                 url: "/carbonx/logger/scope1",
          //                 // icon: "fa fa-truck",
          //               },
          //               {
          //                 name: "Scope 2",
          //                 url: "/carbonx/logger/scope2",
          //                 // icon: "fa fa-bolt",
          //               },
          //               {
          //                 name: "Scope 3",
          //                 url: "/carbonx/logger/scope3",
          //                 // icon: "fa fa-share",
          //               },
          //             ],
          //           },
          //           {
          //             name: "Carbon Invoice",
          //             url: "/carbonx/invoice",
          //             // icon: "fa fa-file-text-o",
          //           },
          //           {
          //             name: "Data Market",
          //             url: "/carbonx/data-market",
          //             // icon: "fa fa-database",
          //           },
          //           // {
          //           //   name: 'Settings',
          //           //   url: '/enermo/settings',
          //           //   icon: 'fa fa-cogs',
          //           // },
          //         ]),
          //   ],
          // },
          {
            name: "Tools",
            url: "/tools",
            icon: "wrench  icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            children: [
              {
                name: "Geocode Converter",
                url: "/tools/geocode-converter",
                // icon: "map icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                badge: {
                  variant: "info",
                  text: "NEW",
                },
              },
              // ...(activeFeature.MY_PERTAMINA_COMPARE_REPORT_FUEL
              //   ? [
              //       {
              //         name: "MyPertamina Converter",
              //         url: "/tools/mypertamina-converter",
              //         // icon: "map icon",
              //         files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              //         badge: {
              //           variant: "info",
              //           text: "NEW",
              //         },
              //       },
              //     ]
              //   : []),
            ],
          },
          // {
          //   name: 'Fleets',
          //   url: '/transporter/fleets',
          //   icon: 'fa fa-car',
          // },
          // {
          //   name: 'Fleet Monitoring',
          //   url: '/transporter/monitoring',
          //   icon: 'fa fa-map',
          // },
          // {
          //   name: 'Drivers',
          //   url: '/transporter/drivers',
          //   icon: 'fa fa-id-badge',
          // },
          // {
          //   name: 'Drivers Assistant',
          //   url: '/transporter/drivers-assistant',
          //   icon: 'fa fa-male',
          // },
          // {
          //   name: 'Delivery Orders',
          //   url: '/transporter/delivery-order',
          //   icon: 'fa fa-file-text',
          // },
          {
            name: "Subscriptions",
            url: "/subscriptions",
            icon: "certificate icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Settings",
            url: "/transporter",
            icon: "cog icon",
            files: [
              "_nav.js",
              "managerNav.jsx",
              "goodsTraderIntercompanyNav.jsx",
              "securityNav.jsx",
            ],
            children: [
              {
                name: "Company Settings",
                url: "/settings",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "securityNav.jsx",
                ],
                // icon: "cogs icon",
              },
              {
                name: "Maintenance Settings",
                url: "/transporter/fleet-maintenance-settings",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                // icon: "cogs icon",
              },
            ],
          },
        ]
      : ["carbon_ethics", "stark_industries"].findIndex(
            (item) => item === apps,
          ) >= 0
        ? carbonMenuWithIcon
        : ["mitratel"].findIndex((item) => item === apps) >= 0
          ? [
              {
                name: "Home",
                url: "/welcome",
                icon: "home icon",
                files: [
                  "_nav.js",
                  "goodsTraderIntercompanyNav.jsx",
                  "hrNav.jsx",
                  "maintenanceNav.jsx",
                ],
              },
              {
                name: "TrackX",
                url: "/transporter",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "headMechanicNav.jsx",
                  "securityNav.jsx",
                  "mechanicNav.jsx",
                  "hrNav.jsx",
                  "maintenanceNav.jsx",
                ],
                icon: ({ hover, className }) => {
                  return (
                    <CarSuv
                      className={className}
                      width={20}
                      height={20}
                      fill={hover ? "#fff" : "#73818f"}
                    />
                  );
                },
                children: [
                  {
                    name: "Main Dashboard",
                    url: "/transporter/dashboard",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "headMechanicNav.jsx",
                      "securityNav.jsx",
                    ],
                    // icon: "icon-speedometer",
                  },
                  {
                    name: wording["Delivery Orders"],
                    url: "/transporter/delivery-order",
                    // icon: "fa fa-file-text",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "securityNav.jsx",
                      "hrNav.jsx",
                      "maintenanceNav.jsx",
                    ],
                  },
                  {
                    name: "Drivers",
                    url: "/transporter/drivers",
                    // icon: "fa fa-id-badge",
                    files: [
                      "_nav.js",
                      "goodsTraderIntercompanyNav.jsx",
                      "hrNav.jsx",
                    ],
                  },
                  {
                    name: "Drivers Assistant",
                    url: "/transporter/drivers-assistant",
                    // icon: "fa fa-male",
                    files: [
                      "_nav.js",
                      "goodsTraderIntercompanyNav.jsx",
                      "hrNav.jsx",
                    ],
                  },
                  {
                    name: wording["Fleets"],
                    url: "/transporter/fleets",
                    // icon: "fa fa-car",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                    ],
                  },
                  {
                    name: "Fleet Operations",
                    url: "/transporter/fleet-operations",
                    // icon: "map signs icon",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "maintenanceNav.jsx",
                    ],
                  },
                  {
                    name: "DO Category",
                    url: "/transporter/delivery/category",
                    // icon: "fa fa-tree",
                    files: ["_nav.js", "hrNav.jsx"],
                  },
                  {
                    name: "Fleet Maintenance",
                    url: "/transporter/fleet-maintenance",
                    // icon: "fa fa-wrench",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "headMechanicNav.jsx",
                      "mechanicNav.jsx",
                    ],
                  },
                  {
                    name: "Live Monitoring",
                    url: "/transporter/live-monitoring",
                    // icon: "eye icon",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "securityNav.jsx",
                    ],
                  },
                  {
                    name: "Main Customers",
                    url: "/transporter/main-customers",
                    // icon: "fa fa-users",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                  {
                    name: "Saved Places",
                    url: "/transporter/saved-places",
                    // icon: "bookmark icon",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                    ],
                  },
                ],
              },
              {
                name: "Settings",
                url: "/transporter",
                icon: "cog icon",
                files: [
                  "_nav.js",
                  "managerNav.jsx",
                  "goodsTraderIntercompanyNav.jsx",
                  "securityNav.jsx",
                ],
                children: [
                  {
                    name: "Company Settings",
                    url: "/settings",
                    files: [
                      "_nav.js",
                      "managerNav.jsx",
                      "goodsTraderIntercompanyNav.jsx",
                      "securityNav.jsx",
                    ],
                    // icon: "cogs icon",
                  },
                  {
                    name: "Maintenance Settings",
                    url: "/transporter/fleet-maintenance-settings",
                    // icon: "cogs icon",
                    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
                  },
                ],
              },
            ]
          : [],
};
